import { getFeatureEnabledForCountry } from '../../../common/hooks/useGetFeatureEnabledForCountry';

export const isJobMetricsEnabledForCountry = (countryCode?: string) =>
  getFeatureEnabledForCountry(countryCode).isJobMetricsEnabledForCountry;
